import { Button, Card, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type Props = {
  searchInput: string;
  onSearchInputChange: (value: string) => void;
  onSearchApply: () => void;
  showInactive: boolean;
  onShowInactiveChange: (value: boolean) => void;
  checkedOutOnly: boolean;
  onCheckedOutOnlyChange: (value: boolean) => void;
  /** 概況バーの「貸出中」トグルがあるときはチェックを出さない */
  showCheckedOutCheckbox?: boolean;
  /** false のとき無効カード切替を隠す */
  showInactiveToggle?: boolean;
  onReload: () => void;
};

/** カード一覧の検索行（少枚数時は親が非表示にし、概況の compactExtras を使う） */
export default function TppCardListFilterBar({
  searchInput,
  onSearchInputChange,
  onSearchApply,
  showInactive,
  onShowInactiveChange,
  checkedOutOnly,
  onCheckedOutOnlyChange,
  showCheckedOutCheckbox = true,
  showInactiveToggle = true,
  onReload,
}: Props) {
  const { t } = useTranslation();

  return (
    <Card className="mb-3 border-0 shadow-sm">
      <Card.Body className="py-2 px-3">
        <div className="d-flex flex-wrap align-items-center gap-2">
          <Form.Label className="small mb-0 visually-hidden" htmlFor="tppCardSearch">
            {t('tpp.search_cards')}
          </Form.Label>
          <div
            className="input-group input-group-sm"
            style={{ maxWidth: '22rem', flex: '1 1 12rem' }}
          >
            <Form.Control
              id="tppCardSearch"
              value={searchInput}
              onChange={(e) => onSearchInputChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onSearchApply();
              }}
              placeholder={t('tpp.search_placeholder')}
              aria-label={t('tpp.search_cards')}
            />
            <Button variant="outline-secondary" className="text-nowrap" onClick={onSearchApply}>
              {t('common.search')}
            </Button>
          </div>
          <Button
            size="sm"
            variant="link"
            className="text-decoration-none text-nowrap px-1"
            onClick={onReload}
          >
            {t('common.reload')}
          </Button>
          {showInactiveToggle ? (
            <Form.Check
              type="checkbox"
              id="tppShowInactive"
              className="mb-0 small"
              label={t('tpp.show_inactive_cards')}
              checked={showInactive}
              onChange={(e) => onShowInactiveChange(e.target.checked)}
            />
          ) : null}
          {showCheckedOutCheckbox && (
            <Form.Check
              type="checkbox"
              id="tppCheckedOutOnly"
              className="mb-0 small"
              label={t('tpp.checked_out_only')}
              checked={checkedOutOnly}
              onChange={(e) => onCheckedOutOnlyChange(e.target.checked)}
            />
          )}
        </div>
      </Card.Body>
    </Card>
  );
}
